// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","index":"App_index__UDXQd","content":"App_content__wwONY","header":"App_header__fhC8n","footer":"App_footer__aawhi"};